<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="element.id!==undefined"
          label="ID" v-model="element.id"
          disabled>
        </v-text-field>

        <v-text-field label="Name"
          v-model="element.name"
          :rules="requiredRules" required>
        </v-text-field>

        <v-text-field label="Image URL"
          v-model="element.image"
          :rules="requiredRules" required>
        </v-text-field>

        <v-btn @click="submit" color="primary">Submit</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['element', 'onSubmit'],
  data() {
    return {
      valid: true,
      menuDate: false,
      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'The field is required';
          return true;
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
